import React, { Component, useState, useEffect, useMemo } from 'react';
import {
  RecoilRoot,
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
} from 'recoil';

import loadable from "@loadable/component";

import {
  BrowserRouter,
  Routes,
  createBrowserRouter,
  RouterProvider,
  Route,
  Navigate,
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';

import { isLogin, profileExists, isReservedPath } from './utils';
import i18n from "./i18n";

import LoadingPage from "./components/pages/home/LoadingPage";


import { isLoggedin, userState, authState } from "./store/stateData";

const algoliasearch = require('algoliasearch');
var client = algoliasearch('0MHBU0LWTD', '529e3e0d75aa7888718f784a83d4aad4');


const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;



const HomePage = loadable(() => import("./components/pages/home/HomePage"), {
   fallback: <LoadingPage />
});



const NoMatch = loadable(() => import("./components/pages/home/NoMatch"), {
   fallback: <LoadingPage />
});


const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <HomePage/>
    ),
  },
  {
    path: "about",
    element: <div>About</div>,
  },
]);

/*
<RouterProvider router={router} />
*/

const ProtectedRoute = ({ isSignedin, children }) => {

  if (!isSignedin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const PublicRoute = ({ isSignedin, children }) => {

  if (isSignedin) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

const runMemorizeCards = cards => {
  console.log('>>> run runMemorizeCards :: ' + cards.length);
  return cards
}

const runMemorizeBillingaddrs = billaddrs => {
  console.log('>>> run runMemorizeBillingaddrs :: ' + billaddrs.length);
  return billaddrs
}

const runMemorizeJobs = jobs => {
  console.log('>>> run runMemorizeJobs :: ' + jobs.length);
  return jobs
}

const runMemorizePayments = payments => {
  console.log('>>> run runMemorizePayments :: ' + payments.length);
  return payments
}

const runMemorizeNotifications = notifs => {
  console.log('>>> runMemorizeNotifications :: ' + notifs.length);
  return notifs
}

const SIZE_PER_PAGE = 30;

const TOKEN_KEY = 'jwtToken';

var ws;

const App = () => {

      const currentYear = new Date().getFullYear();
      const [isSignedin, setIsSignedin] = useRecoilState(isLoggedin);
      const [sinUser, setSinUser] = useRecoilState(userState);
      const [authStatus, setAuthStatus] = useState('init');


      let urlBool;
      if (window.location.pathname.includes('/_pr') || window.location.pathname.includes('/_previewpr')) {
        urlBool = true;
      } else if (window.location.pathname.includes('/search')) {
        urlBool = true;
      } else {
        urlBool = false;
      }

      const urlMatch = urlBool;



      const url = window.location.search;
      const queryParams = new URLSearchParams(url);
      let qrAfter = queryParams.get('after');

      if (qrAfter)
      {
         localStorage.setItem("after", qrAfter);
         localStorage.setItem("params", queryParams);

         //alert(localStorage.getItem("after"))
        // alert(localStorage.getItem("params"))
      }

      //alert(match)



      useEffect(() => {



                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const lang = urlParams.get('l');

             //   alert(localStorage.getItem("language"))

                if (lang !== null && lang !== undefined && lang !== '')
                {
                    if (lang == "fr_FR" || lang == "fr")
                    {

                         localStorage.setItem("language", "fr");
                         i18n.changeLanguage("fr");
                    }
                    else if (lang == "en_US" || lang == "en")
                    {

                         localStorage.setItem("language", "en");
                         i18n.changeLanguage("en");
                    }
                    else
                    {
                         localStorage.setItem("language", "fr");
                         i18n.changeLanguage("fr");
                    }


                }
                else if (localStorage.getItem("language") !== null)
                {
                      var _lang = localStorage.getItem('language');

                      i18n.changeLanguage(_lang);


                }
                else
                {



                        fetch('https://api.ipstack.com/check?access_key=9cd4ffbf45a257de9e644d4d875a9465')
                           .then((response) => response.json())
                           .then((responseData) => {

                             global.country = responseData.country_code;
                             global.city = responseData.city;
                             global.region = responseData.region_name;
                             global.continent = responseData.continent_code;
                             global.ip = responseData.ip;

                             localStorage.setItem("geoLocation", responseData);

                             if (1===2) // isLogin()
                             {

                               /*if (localStorage.getItem('language') === null)
                               {
                                 this.getLanguageFromServer(responseData.country_code);


                               }
                               else
                               {
                                 var _lang = localStorage.getItem('language');
                                   i18n.changeLanguage(_lang);
                               }*/
                             }
                             else
                             {


                                 if (localStorage.getItem('language') === null)
                                {
                                    setLanguage(responseData.country_code);


                                }
                                else
                                {
                                    var _lang = localStorage.getItem('language');
                                   // console.log("Got language from localStore: " + _lang);
                                    i18n.changeLanguage(_lang);
                                }

                             }


                             // .country_code
                             })
                            .catch(function(error) {
                               // alert(error);

                              var _country_code  = "US", _lang = 'en';

                               if (1===2) // isLogin()
                               {
                                 /*if (localStorage.getItem('language') === null)
                                 {

                                  this.getLanguageFromServer(_country_code);
                                 }
                                 else
                                 {
                                   var _lang = localStorage.getItem('language');
                                     i18n.changeLanguage(_lang);
                                 }*/
                               }
                               else
                               {
                                   setLanguage('CD');
                               }


                            }.bind(this));

                  }




        /*async function signalChatSendersThatIReceivedMessages() {

            try {

                let url = `https://bjhg2qil37.execute-api.us-east-1.amazonaws.com/prod/ihavereceivedmessages?uid=Debyoo&t=all`;

                let response = await fetch(url, {method: 'POST'});

                let res = await response.json();

              //  console.log('>> App index ihavereceivedmessages res >> ' + JSON.stringify(res));

                return res;
            }
            catch(error)
            {
               return error;
            }
          }
          signalChatSendersThatIReceivedMessages();*/



          //i18n.changeLanguage('en');







      }, []);



      useEffect(() => {

    //  console.log(JSON.stringify(sinUser));

      /*

        if (isSignedin && sinUser !== null)
        {

             let user= JSON.parse(sinUser);

             authConnection(user);

             countNewNotifs(user);

            // alert(JSON.stringify(user))



              var jwtToken = user.jwt_token; //localStorage.getItem("jwtToken") || '';

              loadYIJTotalRequests(jwtToken);



              fetch('https://api0.debyoo.com/check_cdpresse_auth_grant_api', {
                                        method: 'POST',
                                        headers: {
                                          'Accept': 'application/json',
                                           'Authorization': jwtToken,
                                          'Content-Type': 'application/json'
                                        },
                                         credentials: 'include',
                                        body: JSON.stringify({
                                          auth_check: 'jwt',
                                          access_token: user.access_token,
                                          typef: 'global'
                                        })
                                })
                  .then((response) => response.json())
                  .then((responseData) => {


                         //alert(JSON.stringify(responseData))



                         if (responseData.status == "success")
                         {


                               setAuthStatus(responseData.cdpresse_auth_grants);

                               if (responseData.parent_uid !== undefined && responseData.parent_uid !== null && responseData.parent_uid !== '')
                               {
                                 let hash = {
                                   parent_name: responseData.parent_name,
                                   parent_uid: responseData.parent_uid,
                                   parent_picture: responseData.parent_picture,
                                   parent_email: responseData.parent_email,
                                 }
                                 setParentHash(hash);

                                  loadJobs2(responseData.parent_uid);
                               }
                               else
                               {
                                   let user= JSON.parse(sinUser);
                                   loadJobs2(user.uid);
                               }



                         }
                         else
                         {

                             setAuthStatus('0');
                         }


                     })
                   .catch(function(error) {

                   }.bind(this));



                   // Noitifications
                   loadNotifs();


                   // Cards - Payment methods
                   loadCards();


                   // Billing addresses
                   loadBillingaddrs();

                   // Payments
                   loadPayments();


          }
          else
          {
                localStorage.removeItem('jwtToken');
                localStorage.removeItem('dcUser');

                setTimeout(() => {
                  // window.location = "/";
                },100);
          }
          */


   }, []);


   const setLanguage = (countryCode) => {
      var language = setLanguageFromCountry(countryCode);
      localStorage.setItem("language", language);

      i18n.changeLanguage(language);
   }


   const setLanguageFromCountry = (country) => {


     if (country == "ES" || country == "BO" || country == "CO" || country == "CR" || country == "CU" || country == "DO" || country == "EC" ||
			       country == "GT" || country == "HN" || country == "PA" || country == "PE" || country == "PY" || country == "VE" || country == "UY" ||
			       country == "NI" || country == "CL" || country == "AR" || country == "MX" || country == "PR")
			    {
					var res = "en"; // es
			     }
			     else if (country == "PT" || country == "BR" || country == "AO" || country == "CV" || country == "MZ" || country == "ST" || country == "MO" || country == "TL" || country == "GW")
			   {
				   var res = "en"; //pt
			    }
			   else if (country == "DE" || country == "AT")
			   {
				  var  res = "en";  // de
			   }
			   else if (country == "IN")
			   {
			       var res = "en"; // hi
			   }
			    else if (country == "MY")
			     {
					 var res = "en"; // ms
				}
			    else if (country == "GR" || country == "CY")
			    {
					var res = "en"; //el
			  }
			    else if (country == "RU" || country == "UA")
			   {
			       var res = "en"; //ru
			   }
			    else if (country == "AR" || country == "BO" || country == "CL" || country == "CO" || country == "CR" ||
			         country == "CU" || country == "DO" || country == "EC" || country == "ES" || country == "GQ" ||
			         country == "GT" || country == "HN" || country == "MX" || country == "NI" || country == "PA" ||
			         country == "PE" || country == "PR" || country == "PY" || country == "SV" || country == "UY")
			   {
				   var res = "en"; //es
			   }
			     else if (country == "SE")
			     {
			           var res = "en" //se" Svenska Swedish
				}
			    else if (country == "NL")
			    {
					var res = "en"; //nl" Nederlands Dutch
			    }
			    else if (country == "PL")
			     {
					 var res = "en"; //pl" Polski  Polish
				}
			     else if (country == "RO")
			     {
					 var res = "en"; // ro
			   }
			    else if (country == "DZ" || country == "MA" || country == "TN")
			   {
				   var res = "fr";
			   }
			   else if (country == "AE" || country == "BH" || country == "LB" || country == "EG" || country == "LY" ||
			         country == "IQ" || country == "JO" || country == "MR" || country == "KW" || country == "OM" ||
			         country == "PS" || country == "QA" || country == "SA" || country == "SD" || country == "SO" ||
			         country == "SY" || country == "YE")
			   {
				   var res = "en"; // ar
			   }
			   else if (country == "NL")
			  {
				  var res = "en"; //nl
			   }
			    else if (country == "FR" || country == "BE" || country == "MC" || country == "MQ" || country == "GP" || country == "PF" || country == "RE" || country == "TF" ||
			         country == "BJ" || country == "BF" || country == "CD" || country == "CG" || country == "CI" || country == "GA" || country == "GN" || country == "ML" || country == "NE" || country == "SN" || country == "TG" ||
			         country == "BI" || country == "CM" || country == "CF" || country == "DJ" || country == "GQ" || country == "HT" || country == "LU" || country == "MG" || country == "MR" || country == "MU" || country == "RW" || country == "SC" || country == "TD")
			    {
					var res = "fr";
			   }
			    else
			    {
				    	var res = "en";
			    }



				return res;

   }



   /*
   <Route path="/pr/:id" element={<JobPage isSignedin={isSignedin} sinUser={isSignedin ? sinUser:null}/>} />
   <Route path="/pr/:id/:lg" element={<JobPage isSignedin={isSignedin} sinUser={isSignedin ? sinUser:null}/>} />
   <Route path="/r/:id" element={<JobPage isSignedin={isSignedin} sinUser={isSignedin ? sinUser:null}/>} />
   <Route path="/r/:id/:lg" element={<JobPage isSignedin={isSignedin} sinUser={isSignedin ? sinUser:null}/>} />
   */



    //console.log('>> ---- sinUser >> ' + JSON.stringify(_authStatus));

       return (
         <Translation>
           {
               t =>
              <RecoilRoot>
               <BrowserRouter>
                 <Routes>
                   <Route path="/" element={<PublicRoute isSignedin={isSignedin}><HomePage/></PublicRoute>} />

                   <Route path="*" element={<NoMatch />} />
                 </Routes>
               </BrowserRouter>



             </RecoilRoot>
            }
        </Translation>
      );

}

export default App;
